import { BLOCKED_VALUE_MODAL_ES_MX } from "../components/blocked-value-modal/translations";
import { FUTURE_ENTRIES_INDICATOR_ES_MX } from "../components/future-entries-indicator/translations";
import { FUTURE_ENTRIES_MODAL_ES_MX } from "../components/future-entries-modal/translations";
import { LATEST_TRANSACTIONS_TABLE_ES_MX } from "../components/latest-transactions-table/translations";
import { SAVED_ACCOUNTS_MODAL_ES_MX } from "../components/saved-accounts-modal/translations";
import { TAB_CONTENT_ES_MX } from "../components/tab-content/translations";
import { TABLE_EXTRACT_ES_MX } from "../components/table-extract/translations";
import { WALLET_DRAWER_ES_MX } from "../components/wallet-drawer/translations";
import { WALLET_INDICATOR_ES_MX } from "../components/wallet-indicator/translations";
import { FLOW_EXTRACT_ES_MX } from "../pages/flow/translations";
import { BANKSLIP_PAYMENT_ES_MX } from "../components/bankslip-payment/translations";
import { ExtractTranslations } from "./extract-pt-br";

export const EXTRACT_ES_MX: ExtractTranslations = {
	title: "Cuenta de Pago",
	graphics: "Gráfica",
	subtitle: `Siga sus movimientos financieros de forma clara y comprenda sus transacciones,
		faturas y retiros de forma práctica.`,
	oldExtract: "Extrato Legado",
	oldExtractExpireAt: "Hasta 05/08/2025",
	walletIndicator: WALLET_INDICATOR_ES_MX,
	futureEntriesIndicator: FUTURE_ENTRIES_INDICATOR_ES_MX,
	tab: TAB_CONTENT_ES_MX,
	tableExtract: TABLE_EXTRACT_ES_MX,
	futureEntriesModal: FUTURE_ENTRIES_MODAL_ES_MX,
	walletDrawer: WALLET_DRAWER_ES_MX,
	savedAccountsModal: SAVED_ACCOUNTS_MODAL_ES_MX,
	latestTransactions: LATEST_TRANSACTIONS_TABLE_ES_MX,
	flow: FLOW_EXTRACT_ES_MX,
	blockedValueModal: BLOCKED_VALUE_MODAL_ES_MX,
	bankslipPayment: BANKSLIP_PAYMENT_ES_MX,
	filterBy: "Filtrar por",
	typeFilter: "Escriba un filtro",
	groupFilter: "Filtrar por Grupo",
	categoryFilter: "Filtrar por Categoría",
	groupBy: "Agrupar por",
	groupedBy: "Agrupado",
	drawer: {
		withdraw: "Retiro",
		anticipation: "Anticipación",
		ticketPayment: "Pago de Boletos",
		transferBetweenPlaces: "Transferencia entre Lugares",
	},
	search: {
		emptyState: "No se encontraron filtros",
		clearAllTooltip: "Borrar todos los filtros",
		allItems: "Todos los items",
	},
};
